<template>
	<div class="skeleton-carousel">
		<div
				v-for="n in items"
				:key="n"
				class="skeleton skeleton-square"
		></div>
	</div>
</template>

<script>
export default {
	name: "SkeletonCarousel",
	props: {
		items: {
			type: Number,
			default: 4
		}
	}
};
</script>

<style scoped>
.skeleton-carousel {
	display: flex;
	gap: 1rem;
	padding: 1rem;
	justify-content: center;
}

.skeleton {
	background: linear-gradient(90deg, #454545 25%, #202020 37%, #454545 63%);
	background-size: 400% 100%;
	animation: shimmer 1.4s ease infinite;
	border-radius: 8px;
}

.skeleton-square {
	width: 80px;
	height: 80px;
}

@keyframes shimmer {
	0% { background-position: -400px 0; }
	100% { background-position: 400px 0; }
}
</style>
